// 무한 스크롤 sentinel — 뷰포트에 들어오면 onEnter 로 다음 페이지를 요청한다.
import { useEffect, useRef } from 'react';
import styles from './MediaCenter.module.css';

export function LoadMoreSentinel({ onEnter, hasMore }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !hasMore) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) onEnter();
      },
      { rootMargin: '100px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [onEnter, hasMore]);

  if (!hasMore) return null;

  return (
    <div ref={ref} className={styles.loadMore}>
      <div className={styles.skel}>
        {[0, 1, 2].map((i) => (
          <div key={i} className={styles.skelItem}>
            <div className={styles.skelThumb} />
            <div className={styles.skelLine} />
            <div className={`${styles.skelLine} ${styles.skelLineShort}`} />
          </div>
        ))}
      </div>
      <div className={styles.spinner} />
      <div className={styles.loadMoreLabel}>스크롤하여 더 보기</div>
    </div>
  );
}
